import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from "angular2-notifications";
import * as moment from "moment/moment";
import { IMyDpOptions } from 'mydatepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateUtilService } from '../../../../shared/services/date-util.service';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { CadastroFuncionarioService } from './cadastro-funcionario.service';
import { EnderecoUtils } from '../../../../shared/utils/EnderecoUtils';

@Component({
  selector: 'ngx-cadastro-funcionario',
  templateUrl: './cadastro-funcionario.component.html',
  styleUrls: ['./cadastro-funcionario.component.scss'],
})

export class CadastroFuncionarioComponent implements OnInit {

  //Form control

  public funcionarioId = null;
  public pessoaId = null;
  public pessoaCpf = null;
  public endereçoId = null;
  public isRegister = null;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    //disableUntil: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1 }
  };

  public listCardTipoDoc = null;
  public listCardSexo = null;
  public listCardEstadoCivil = null;
  public listaEstado = null;
  public listaTplogradouro = null;
  public filterForm: FormGroup = null;
  public cpf = null;
  public parentForm: any;
  public saveCadastrarUsuario: FormGroup;
  public customLogin = null;
  public listOptEmissaoCartao = null;
  public isEditavel: boolean = false;
  public permiteSalvar: boolean = false;

  constructor(
    private notifications: NotificationsService,
    private cadastroFuncionarioService: CadastroFuncionarioService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private location: Location,
    private service: CadastroFuncionarioService,
    private dateUtilService: DateUtilService,
    private spinnerService: NgxSpinnerService,
    private router: Router,
    private enderecoUtils: EnderecoUtils,
  ) {

    this.activatedRoute.queryParamMap.subscribe(params => {
      this.funcionarioId = this.encriptyService.decriptyBySecretKey(params.get('funcionarioId'));
      this.pessoaId = this.encriptyService.decriptyBySecretKey(params.get('pessoaId'));
      this.pessoaCpf = this.encriptyService.decriptyBySecretKey(params.get('pessoaCpf'));
      this.endereçoId = this.encriptyService.decriptyBySecretKey(params.get('endereçoId'));
      this.isRegister = this.encriptyService.decriptyBySecretKey(params.get('isRegister'));
    });

    this.filterForm = this.formBuilder.group({
      id: [null],
      pessoaId: [null],
      status: [null],
      nome: [null, Validators.required],
      nomeMae: [null, Validators.required],
      nomePai: [null],
      nomeSocial: [null],
      matricula: [null, Validators.required],
      cpf: [null, Validators.required],
      statusCpf: [null, Validators.required],
      numeroDocumentoOficial: [null],
      tipoDocumentoOficial: [null],
      orgaoExpedidor: [null],
      nacionalidade: [null],
      naturalidade: [null],
      sexo: [null, Validators.required],
      estadoCivil: [null],
      dataAdmissao: [null, Validators.required],
      dataNascimento: [null, Validators.required],
      dataExpedicaoDocumento: [null],
      email: [null, Validators.required],
      cargo: [null, Validators.required],
      telefoneCelular: [null, [Validators.required, Validators.pattern("^\([1-9]{2}\)(?:[2-8]|9[1-9])[0-9]{3}[0-9]{4}$")]],
      cep: [null, Validators.required],
      estado: [null, Validators.required],
      localidade: [null, Validators.required],
      bairro: [null, [Validators.required, Validators.maxLength(19)]],
      complemento: [null],
      logradouro: [null, Validators.required],
      tipoLogradouro: [null],
      numero: [null, Validators.required],
      emissaoCartao: ['N'],
    });

    if (this.funcionarioId != null) {

      this.buscaFuncionario(this.pessoaCpf);
    }

    this.listCardTipoDoc = [

      {
        tipoDocumentoOficial: 'RG',
        descricao: 'RG'
      },
      {
        tipoDocumentoOficial: 'CNH',
        descricao: 'CNH'
      },
      {
        tipoDocumentoOficial: 'CPF',
        descricao: 'CPF'
      },
    ];

    this.listCardSexo = [

      {
        sexo: 'M',
        descricao: 'MASCULINO'
      },

      {
        sexo: 'F',
        descricao: 'FEMININO'
      },

    ];

    this.listCardEstadoCivil = [

      {
        estadoCivil: 'SOLTEIRO',
        descricao: 'SOLTEIRO'
      },
      {
        estadoCivil: 'CASADO',
        descricao: 'CASADO'
      },
      {
        estadoCivil: 'SEPARADO',
        descricao: 'SEPARADO'
      },
      {
        estadoCivil: 'DIVORCIADO',
        descricao: 'DIVORCIADO'
      },
      {
        estadoCivil: 'VIUVO',
        descricao: 'VIUVO'
      },
      {
        estadoCivil: 'UNIAO_ESTAVEL',
        descricao: 'UNIAO ESTAVEL'
      },

    ];

    this.listaTplogradouro = [

      {
        value: 'AVENIDA',
        descricao: 'Avenida'
      },

      {
        value: 'RUA',
        descricao: 'Rua'
      },

      {
        value: 'FAZENDA',
        descricao: 'Fazenda'
      },

      {
        value: 'LOTEAMENTO',
        descricao: 'Loteamento'
      },

      {
        value: 'RODOVIA',
        descricao: 'Rodovia'
      },

      {
        value: 'PRAÇA',
        descricao: 'Praça'
      },

      {
        value: 'OUTRO',
        descricao: 'Outro'
      }
    ]

    this.listaEstado = this.enderecoUtils.ufList;

    this.listOptEmissaoCartao = [
      {
        descricao: 'SIM',
        valor: 'S'
      },
      {
        descricao: 'NÃO',
        valor: 'N'
      },
    ];

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
  }

  saveFormCadastro(data) {
    if (!this.filterForm.valid) {
      this.validateAllFormFields(this.filterForm);
      return;
    }
    this.spinnerService.show();
    let dataNascimento: string = this.dateUtilService.datepickerTransformDate(data.dataNascimento, 'YYYY-MM-DD');
    let dataExpedicaoDocumento: string = data.dataExpedicaoDocumento ? this.dateUtilService.datepickerTransformDate(data.dataExpedicaoDocumento, 'YYYY-MM-DD') : null;
    let dataAdmissao: string = this.dateUtilService.datepickerTransformDate(data.dataAdmissao, 'YYYY-MM-DD');
    let productId = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));


    let register: any = {
      pessoa: {
        id: data.pessoaId,
        nome: data.nome,
        cpf: data.cpf,
        statusCpf: data.statusCpf,
        dataNascimento: dataNascimento,
        sexo: data.sexo,
        telefoneCelular: data.telefoneCelular,
        email: this.filterForm.get("email").value.trim(),
        nomeMae: data.nomeMae,
        nomePai: data.nomePai,
        nomeSocial: data.nomeSocial,
        estadoCivil: data.estadoCivil,
        tipoDocumentoOficial: data.tipoDocumentoOficial,
        numeroDocumentoOficial: data.numeroDocumentoOficial,
        orgaoExpedidor: data.orgaoExpedidor,
        dataExpedicaoDocumento: dataExpedicaoDocumento,
        nacionalidade: data.nacionalidade,
        naturalidade: data.naturalidade,
      },
      funcionario: {
        id: data.id,
        cargo: data.cargo,
        matricula: data.matricula,
        dataAdmissao: dataAdmissao,
        status: data.status,
      },
      endereco: {
        bairro: data.bairro,
        cep: data.cep,
        complemento: data.complemento,
        estado: data.estado,
        localidade: data.localidade,
        logradouro: data.logradouro,
        numero: data.numero,
        tipoLogradouro: data.tipoLogradouro,
      }
    };


    if (this.isRegister === 'S') {

      this.cadastroFuncionarioService.saveCadastrarUsuario(register, (response) => {
        this.formatSaveCadastro(response);
        this.spinnerService.hide();
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });


    } else if (this.isRegister === 'N') {
      this.cadastroFuncionarioService.updateCadastrarUsuario(register, (response) => {
        this.formatSaveCadastro(response);
        this.spinnerService.hide();
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });

    } else {
      this.notifications.error('Não foi possível encontrar a natureza da operação');
    }

  }

    formatSaveCadastro(ret) {
      if (ret || ret == null) {
        this.filterForm.reset();

        this.filterForm.patchValue({
          emissaoCartao: 'N'
        });

        this.notifications.success('Colaborador salvo com sucesso!');
      }
    }

    limparCampos() {
      this.filterForm.reset();

      this.filterForm.patchValue({
        emissaoCartao: 'N'
      });
    }


consultaCPF(data: any) {
  this.spinnerService.show();
  if (data.cpf != null && data.cpf !== "") {
    this.limparForm();
    this.service.pesquisarUsuario(
      data.cpf, null,
      (response) => {
        this.buscaUsuario(response);
      },
      (error) => {
        if (error.message != 'CPF invalido') {

          this.limparForm();
          this.cpf = data.cpf;
          this.filterForm.controls['cpf'].setValue(this.cpf);
          this.filterForm.controls['statusCpf'].setValue('REGULAR');

          //Habilita o campo de e-mail mesmo que tenha erro na consulta CPF
          this.filterForm.get('email').enable();
          this.permiteSalvar = true;

          this.spinnerService.hide();
        } else {
          this.filterForm.controls['cpf'].setValue(null);
          this.filterForm.controls['statusCpf'].setValue(null);
          this.notifications.error(error.message);
          this.limparForm();
          this.spinnerService.hide();
        }
        this.spinnerService.hide();
      });
  } else {
    this.limparForm();
    this.spinnerService.hide();
  }
}


  limparForm() {
    this.filterForm.reset();
  }

  buscaFuncionario(data: any) {
    if (data != null) {
            this.spinnerService.show();
      this.service.pesquisaPessoaCpf(data, null, (response) => {
        this.buscaUsuario(response);
        this.spinnerService.hide();
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error('Não foi possível buscar informações do funcionário');
      });
    }
  }

  buscaUsuario(data: any) {
    const emailControl = this.filterForm.get('email');
    this.isEditavel = data.editavel;
    if (data.editavel) {
      emailControl.enable();
      this.permiteSalvar = true;
    } else {
      emailControl.disable();
      emailControl.clearValidators()
      emailControl.updateValueAndValidity();
      this.permiteSalvar = true;
    }

    this.preencherDadosPessoa(data.pessoa);
    this.preencherDadosEndereco(data.endereco);
    this.preencherDadosFuncionario(data.funcionario);
    this.consultaMatricula(this.filterForm.value.cpf, this.filterForm.value.matricula);
  }


  preencherDadosPessoa(pessoa: any) {
    if (!pessoa) return;
    this.filterForm.patchValue({
      pessoaId: pessoa.id,
      nome: pessoa.nome,
      nomeMae: pessoa.nomeMae,
      nomePai: pessoa.nomePai,
      nomeSocial: pessoa.nomeSocial,
      cpf: pessoa.cpf,
      statusCpf: pessoa.statusCpf,
      numeroDocumentoOficial: pessoa.numeroDocumentoOficial,
      tipoDocumentoOficial: pessoa.tipoDocumentoOficial,
      orgaoExpedidor: pessoa.orgaoExpedidor,
      nacionalidade: pessoa.nacionalidade,
      naturalidade: pessoa.naturalidade,
      sexo: pessoa.sexo,
      estadoCivil: pessoa.estadoCivil,
      dataNascimento: pessoa.dataNascimento ? this.criarData(pessoa.dataNascimento) : null,
      dataExpedicaoDocumento: pessoa.dataExpedicaoDocumento ? this.criarData(pessoa.dataExpedicaoDocumento) : null,
      email: pessoa.email,
      telefoneCelular: pessoa.telefoneCelular
    });
  }

  preencherDadosEndereco(endereco: any) {
    if (!endereco) return;
    this.filterForm.patchValue({
      cep: endereco.cep,
      estado: endereco.estado,
      localidade: endereco.localidade,
      logradouro: endereco.logradouro,
      bairro: endereco.bairro,
      complemento: endereco.complemento,
      numero: endereco.numero,
      tipoLogradouro: this.listaTplogradouro.find(tipo => tipo.value === endereco.tipoLogradouro) ? this.listaTplogradouro.find(tipo => tipo.value === endereco.tipoLogradouro).value : null
    });
  }

  preencherDadosFuncionario(funcionario: any) {
    if (!funcionario) return;
    this.filterForm.patchValue({
      id: funcionario.id,
      matricula: funcionario.matricula,
      cargo: funcionario.cargo,
      status: this.isRegister === 'S' ? 'ATIVO' : this.isRegister === 'N' && this.funcionarioId ? funcionario.status : null,
      dataAdmissao: funcionario.dataAdmissao ? this.criarData(funcionario.dataAdmissao) : null
    });
    if (!this.filterForm.controls['status'].value) {
      this.notifications.error('Não foi possível determinar a operação');
    }
  }

  criarData(data: string) {
    const date = moment(data, 'YYYY-MM-DD').toDate();
    return {
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    };
  }

  fecharForm() {

    this.location.back();

  }

  consultaMatricula(matricula, cpf) {
    this.spinnerService.show();
    if (matricula != null && cpf != null) {
      let params = new HttpParams();

      params = params.append('matricula', matricula);
      params = params.append('cpf', cpf);


      this.service.validateRegistration(params, (response) => {

        if (response) {

          this.filterForm.controls['matricula'].setValue(null);
          this.notifications.error('Matrícula em uso para outro Funcionário');
          this.spinnerService.hide();
        }

      }, null);
      this.spinnerService.hide();
    } else {
      this.spinnerService.hide();
    }

  }


  validateEmail(event: any) {
    if (this.isEditavel) {
      this.service.validateEmail({
        email: event.target.value,
        cpf: this.filterForm.get('cpf').value,
      }, () => {
        this.permiteSalvar = true;
      }, (error) => {
        this.notifications.error(error.message);
        this.permiteSalvar = false;
      });
    }
  }

  consultaCEP(data) {

    this.cadastroFuncionarioService.address(data, null, (response) => {
      this.buscaEndereco(response);
    }, null);
  }

  buscaEndereco(data) {

    if (data.cep === null) {
      this.notifications.error('CEP não existe!!!');
    } else {

      let tipoLogradouro = data.logradouro.split(" ")[0];
      let logradouro = data.logradouro.split(tipoLogradouro + " ")[1];

      this.filterForm.controls['cep'].setValue(data.cep);
      this.filterForm.controls['estado'].setValue(data.estado);
      this.filterForm.controls['logradouro'].setValue(logradouro);
      this.filterForm.controls['tipoLogradouro'].setValue(tipoLogradouro);
      this.filterForm.controls['complemento'].setValue(data.complemento);
      this.filterForm.controls['localidade'].setValue(data.localidade);
      this.filterForm.controls['estado'].setValue(data.uf);
      this.filterForm.controls['bairro'].setValue(data.bairro.substring(0, 19));


    }
  }

  numberOnly(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  formateDateSaveBD(data) {
    return new Date(data).getTime();
  }

  previousPage() {
    this.location.back();
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  fecharTela() {
    this.router.navigate(['/pages/gestao-funcionarios/lista-funcionario']);
  }

}
